import { ParamsHelper } from '../../helpers/ParamsHelper';
import { ApiHttpService } from '../ApiHttpService';
import { InfoAndQuestionsSerializer } from '../serializers/InfoAndQuestionsSerializer';
import { CustomerServiceSerializer } from '../serializers/CustomerServiceSerializer';
import { InfoAndQuestions } from '../../models/InfoAndQuestions';
import { CustomerService } from '../../models/CustomerService';

const SERVICE_TRACKING_FOLLOW_PATH = 'Usuario/SeguirServicio';
const SERVICE_TRACKING_UPDATE_DATA_PATH = 'Usuario/SeguirServicioConDatos';
const SERVICE_TRACKING_UPDATE_PATH = 'Usuario/ConfirmarServicio';

class ServiceTrackingController {
  static async getCustomerInfo(data) {
    const objectParams = {
      token: data.token,
    };
    const params = ParamsHelper.createQueryParams(objectParams);
    const response = await ApiHttpService.get(`${SERVICE_TRACKING_UPDATE_DATA_PATH}${params}`);
    const deSerializedData = CustomerServiceSerializer.deSerialize(response.data);
    return new CustomerService(deSerializedData);
  }

  static async find(data) {
    const objectParams = {
      identificador: data.personalIdOrRut,
      idServicio: data.serviceId,
    };
    const params = ParamsHelper.createQueryParams(objectParams);
    const headers = {
      captcha: data.recaptchaToken,
    };
    const response = await ApiHttpService.get(`${SERVICE_TRACKING_FOLLOW_PATH}${params}`, {}, false, { headers });
    const deSerializedData = InfoAndQuestionsSerializer.deSerialize(response.data);
    return new InfoAndQuestions(deSerializedData);
  }

  static async update(data) {
    const objectParams = {
      identificador: data.personalIdOrRut,
      idServicio: data.serviceId,
      acepta: data.accept,
      disposicion: data.dispose,
    };
    const params = ParamsHelper.createQueryParams(objectParams);
    const response = await ApiHttpService.post(`${SERVICE_TRACKING_UPDATE_PATH}${params}`);
    const deSerializedData = InfoAndQuestionsSerializer.deSerialize(response.data);
    return new InfoAndQuestions(deSerializedData);
  }
}

export { ServiceTrackingController };



// WEBPACK FOOTER //
// ./src/networking/controllers/ServiceTrackingController.js